import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var HearingDeafSvg = function HearingDeafSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.553 5.274a5.48 5.48 0 0 1 3.893-1.63c1.461 0 2.862.586 3.894 1.63a5.6 5.6 0 0 1 1.613 3.933c0 1.704-.75 3.24-2.57 5.038-.943.933-1.68 1.638-2.181 2.11a67 67 0 0 1-.715.662l-.036.033-.008.008-.234.21v.313c0 .707-.158 1.553-.572 2.198-.387.605-1.019 1.075-2.12 1.075-.751 0-1.25-.2-1.592-.47l-.85 1.098c.62.491 1.431.767 2.441.767 1.59 0 2.65-.726 3.28-1.712.535-.834.744-1.82.786-2.639q.198-.18.561-.522c.509-.48 1.255-1.193 2.207-2.134 1.97-1.947 2.984-3.82 2.984-6.035a7 7 0 0 0-2.017-4.92 6.85 6.85 0 0 0-4.87-2.038 6.85 6.85 0 0 0-4.871 2.038 7 7 0 0 0-2.018 4.92H6.94c0-1.475.58-2.89 1.613-3.933M18.467 3.428a8.4 8.4 0 0 1 1.743 2.79l1.29-.5a9.8 9.8 0 0 0-2.033-3.252z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.946 6.71a3.52 3.52 0 0 1 2.5-1.046c.938 0 1.838.376 2.501 1.046a3.6 3.6 0 0 1 1.036 2.526H14.6c0-.577-.227-1.131-.63-1.54a2.14 2.14 0 0 0-1.524-.637c-.572 0-1.12.23-1.524.638a2.2 2.2 0 0 0-.631 1.539v1.018H8.91V9.237A3.6 3.6 0 0 1 9.946 6.71M6.716 11.812l3.4 3.436.977-.987-3.4-3.435zM5.9 19.393l-3.4-3.436.977-.986 3.4 3.435zM5.436 14.668l1.81 1.828.976-.987-1.81-1.828z"
  }));
};
export var HearingDeaf = function HearingDeaf(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: HearingDeafSvg
  }));
};